import { initializeApp, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider, type Auth } from 'firebase/auth';
import { connectFirestoreEmulator, initializeFirestore, type Firestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions, type Functions } from 'firebase/functions';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
const missing = (['apiKey', 'authDomain', 'projectId', 'appId'] as const).filter((key) => !config[key]);
export const configError = missing.length ? `Missing Firebase configuration: ${missing.join(', ')}.` : null;

let appInstance: FirebaseApp | undefined;
let authInstance: Auth | undefined;
let dbInstance: Firestore | undefined;
let functionsInstance: Functions | undefined;
if (!configError) {
  appInstance = initializeApp(config);
  authInstance = getAuth(appInstance);
  dbInstance = initializeFirestore(appInstance, { ignoreUndefinedProperties: true });
  // Compass Manage has no Cloud Functions of its own — this calls
  // Compass's existing functions (us-central1, the same project) directly,
  // e.g. setEntitlement. See src/lib/data.ts.
  functionsInstance = getFunctions(appInstance, 'us-central1');
  if (import.meta.env.VITE_USE_EMULATORS) {
    connectAuthEmulator(authInstance, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(dbInstance, 'localhost', 8080);
    connectFunctionsEmulator(functionsInstance, 'localhost', 5001);
  }
}
export const auth = authInstance as Auth;
export const db = dbInstance as Firestore;
export const functions = functionsInstance as Functions;
export const googleProvider = new GoogleAuthProvider();
